import React from "react";
import { Route, Switch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Numbike from "../components/Number BikePage/Numbike";
import Numhealth from "../components/Number HealthPage/NumHealth";
import Numtravel from "../components/Number TravelPage/NumTravel";
import Numcar from "../components/Number CarPage/Numcar";
import Numlife from "../components/Number LifePage/NumLife";
import PolicySteps2 from "../components/Policy detail page car/PolicySteps";
import PolicyStepsBike from "../components/Policy detail page bike/PolicySteps";
import PolicyStepsHealth from "../components/Policy detail page health/PolicyStepsHealth";
import PolicySteps3 from "../components/Policy detail page health/PolicySteps";
import PolicySteps4 from "../components/Policy detail page commercial/PolicySteps";
import PolicySteps5 from "../components/Policy detail page travel/PolicySteps";
import Twheelmake from "../components/RolloverBike/VehicleMake/Twheelmake";
import Fwheelmake from "../components/RolloverCar/VehicleMake/Fwheelmake";
import Healthmake from "../components/vehicle details/Healthmake";
import Carnotodetails from "./Bike no to Bike details/CarNotoDetails";
import Commercialnotodetails from "./Bike no to Bike details/Commercialnotodetails";
import Travelnotodetails from "./Bike no to Bike details/Travelnotodetails";
import Lifenotodetails from "./Bike no to Bike details/Lifenotodetails";
import { PlanLayoutBike } from "../components/RolloverBike/planPageLayoutBike";
import { PlanLayout2 } from "../components/RolloverCar/planPageLayout";
import { PlanLayout3 } from "../components/plansPageHealth/planPageLayout";
import { PlanLayoutLife } from "../components/plansPageLife/planPageLayout";
import { PropLayout1 } from "../components/proposols/step1/prop1layout";
import { PropLayout2 } from "../components/proposols/step2/prop2layout";
import { PropLayout3 } from "../components/proposols/step3/prop3layout";
import { Home } from "../components/Home Page/Home";
import { Login } from "../components/LoginPage/Logni";
import { LoginCar } from "../components/LoginPage/LoginCar";
import { PaymentDetails } from "../components/PaymentDetails/PaymentDetails";
import { PaymentDetailsHealth } from "../components/PaymentDetails/PaymentDetailsHealth";
import { HealthCredit } from "../components/CreditCard/HealthCredit";
import { Credit } from "../components/CreditCard/Credit";
import { IciciCredit } from "../components/CreditCard/IciciCredit";
import { CarCredit } from "../components/CreditCard/CarCredit";
import { IciciCarCredit } from "../components/CreditCard/IciciCarCredit";
import { Paydone } from "../components/Lastpay/Paydone";
import { PospLogin } from "../components/LoginPage/PospLogin";
import StepForm from "../components/vehicle details/StepForm";
import { Error } from "../components/ErrorPage/Error";
import CustomerInfo from "../components/Policy detail page bike/CustomerInfo";
import PospMake from "../components/Posp/PospMake";
import PospNumBike from "../components/Number BikePage/PospNumBike";
import { PospMenu } from "../components/Posp/Menu";
import PospDetail from "../components/Posp/PospDetails";
import PospNumCar from "../components/Number CarPage/PospNumCar";
import PospCarMake from "../components/Posp/PospCarMake";
import PospNumcommercial from "../components/Number CommercialPage/PospNumComm";
import CarCustomerInfo from "../components/Policy detail page car/CarCustomerInfo";
import CommercialMake from "../components/Posp/CommercialMake";
import CompareView from "../components/RolloverBike/CompareView";
import CarCompareView from "../components/RolloverCar/CarCompareView";
import { UATLogin } from "../components/UatLogin/UATLogi";
import { CarPaymentDetails } from "../components/PaymentDetails/CarPayDetails";
import { OtpLogin } from "../components/PospOnboard/OtpLogin";
import { ONBProfileDetails } from "../components/PospOnboard/ProfileDetails";
import OnboardStep from "../components/PospOnboard/OnboardStep";
import ProfileTab from "../components/PospOnboard/ProfileTab";
import HealthCustomerInfo from "../components/plansPageHealth/HCustomerInfo";
import PospDashBoard from "../components/PospOnboard/Dashboard";
import OfflineLife from "../components/Number LifePage/OfflineLife";
import TemplatePdf from "../components/GeneratePdf/Template";
import NewBikemake from "../components/New Vehicle/Bike/BikeMake";
import { NewPlanLayoutBike } from "../components/New Vehicle/Bike/NewPlanLayoutBike";
import CustomerInfoNew from "../components/New Vehicle/Bike/NewCustomerInfo";
import { BikeLogin } from "../components/New Vehicle/Bike/Login";
import { BikePaymentDetailNew } from "../components/New Vehicle/Bike/PaymentDetail";
import ComRegister from "../components/RolloverCommercial/Register/ComRegister";
import ComVehType from "../components/RolloverCommercial/VehicleMake/ComVehType";
import PolicyStepC from "../components/RolloverCommercial/PolicyStep/PolicyStepC";
import PlanLayoutCommercial from "../components/RolloverCommercial/PlanLayout/PlanLayoutCommercial";
import CommercialCustomerInfo from "../components/RolloverCommercial/Proposal/Customer";
import Disclaimer from "../components/Legal/Disclaimer";
import PrivacyPolicy from "../components/Legal/PrivacyPolicy";
import TermsOfUse from "../components/Legal/TermsOfUse";
import Contact from "../components/Legal/Contact";
import BecomePosp from "../components/Posp/BecomePosp";


function App() {
  const dispatch = useDispatch();
  // const history = useHistory();
  const OTPData = useSelector((state) => state?.posp?.onbNum);
  const isLoggedIn = OTPData?.accessToken;
  // const UatLog = useSelector((state) => state?.test?.uaLogin);

  setTimeout(() => {
    dispatch((dispatch) => {
      dispatch({ type: "RESET_COMMON" });
      dispatch({ type: "RESET_CAR" });
      dispatch({ type: "RESET_BIKE" });
      dispatch({ type: "RESET_LIFE" });
      dispatch({ type: "RESET_UAT" });
      dispatch({ type: "LOGOUT_POSP" });
    });
  }, 43200000);
  return (
    <>
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>
        {/* <Route path="/home" exact>
          {isLoggedInUat ? <Home /> : <UATLogin />}
        </Route>
        <Route path="/" exact>
          {isLoggedInUat ? <Home /> : <UATLogin />}
        </Route> */}
        <Route path="/become-posp" exact>
          <BecomePosp />
        </Route>
        <Route path="/OtpLogin" exact>
          {isLoggedIn ? <ONBProfileDetails /> : <OtpLogin />}
        </Route>
        <Route path="/profileDetails" exact>
          {isLoggedIn ? <ONBProfileDetails /> : <OtpLogin />}
        </Route>
        <Route path="/TemplatePdf" exact>
          <TemplatePdf />
        </Route>
        <Route path="/onboardProcess" exact>
          <OnboardStep />
        </Route>
        <Route path="/ProfileView" exact>
          <ProfileTab />
        </Route>
        <Route path="/Dashboard" exact>
          <PospDashBoard />
        </Route>
        <Route path="/travelstep" exact>
          <StepForm />
        </Route>
        <Route path="/PospMenu" exact>
          <PospMenu />
        </Route>
        <Route path="/PospDetail" exact>
          <PospDetail />
        </Route>
        <Route path="/login" exact>
          <Login />
        </Route>
        <Route path="/carlogin" exact>
          <LoginCar />
        </Route>
        <Route path="/Posplogin" exact>
          <PospLogin />
        </Route>
        <Route path="/PospNum" exact>
          <PospNumBike />
        </Route>
        <Route path="/OfflineCar" exact>
          <PospNumCar />
        </Route>
        <Route path="/PospMake" exact>
          <PospMake />
        </Route>
        <Route path="/offlineCarMake" exact>
          <PospCarMake />
        </Route>
        <Route path="/Offlinecommercial" exact>
          <PospNumcommercial />
        </Route>
        <Route path="/offCommercialMake" exact>
          <CommercialMake />
        </Route>
        <Route path="/carno" exact>
          {/* <Carnotodetails /> */}
          <Numcar />
        </Route>
        <Route path="/cardetail" exact>
          {/* <Carnotodetails /> */}
          <Fwheelmake />
        </Route>
        <Route path="/bikeno" exact>
          {/* <Bikenotodetails /> */}
          <Numbike />
        </Route>
        <Route path="/view" exact>
          <CompareView />
        </Route>
        <Route path="/compareplan" exact>
          <CarCompareView />
        </Route>
        <Route path="/bikedetail" exact>
          {/* <Bikenotodetails /> */}
          <Twheelmake />
        </Route>
        <Route path="/CustomerInfo" exact>
          <CustomerInfo />
        </Route>
        <Route path="/Customer" exact>
          <CarCustomerInfo />
        </Route>
        {/* Health */}
        <Route path="/healthno" exact>
          {/* <Healthnotodetails /> */}
          <Numhealth />
        </Route>
        <Route path="/healthdetail" exact>
          {/* <Healthnotodetails /> */}
          <Healthmake />
        </Route>
        <Route path="/CustomerHealth" exact>
          <HealthCustomerInfo />
        </Route>
        <Route path="/traveldetail" exact>
          <Travelnotodetails />
          {/* <Travelmake /> */}
        </Route>
        <Route path="/travelno" exact>
          <Travelnotodetails />
          <Numtravel />
        </Route>
        <Route path="/lifedetail" exact>
          <Lifenotodetails />
          {/* <Lifemake /> */}
        </Route>
        <Route path="/lifeno" exact>
          <Lifenotodetails />
          <Numlife />
        </Route>
        <Route path="/lifeOffline" exact>
          <OfflineLife />
        </Route>
        <Route path="/policystep2" exact>
          <PolicySteps2 />
        </Route>

        <Route path="/policystepbike" exact>
          <PolicyStepsBike />
        </Route>

        <Route path="/policystephealth" exact>
          <PolicyStepsHealth />
        </Route>

        <Route path="/policystep5" exact>
          <PolicySteps5 />
        </Route>

        <Route path="/policystep3" exact>
          <PolicySteps3 />
        </Route>
        <Route path="/policystepCommercial" exact>
          <PolicySteps4 />
        </Route>
        {/* <Route path="/policystep" exact>
          <PolicySteps />
        </Route> */}

        {/* <Route path="/planlayout" exact>
          <PlanLayout />
        </Route> */}
        <Route path="/planlayoutbike" exact>
          <PlanLayoutBike />
        </Route>
        {/* <Route path="/planlayouthealth" exact>
          <PlanLayoutHealth />
        </Route> */}
        <Route path="/planlayout2" exact>
          <PlanLayout2 />
        </Route>
        <Route path="/planlayout3" exact>
          <PlanLayout3 />
        </Route>
        <Route path="/lifeLayout" exact>
          <PlanLayoutLife />
        </Route>
        {/* <Route path="/planlayout4" exact>
          <PlanLayout4 />
        </Route> */}
        {/* <Route path="/planlayout5" exact>
          <PlanLayout5 />
        </Route> */}
        <Route path="/step1" exact>
          <PropLayout1 />
        </Route>
        {/* <Route path="/healthstep1" exact>
          <PropLayout12 />
        </Route> */}
        {/* <Route path="/healthstep2" exact>
          <PropLayout22 />
        </Route> */}
        <Route path="/step2" exact>
          <PropLayout2 />
        </Route>

        <Route path="/step3" exact>
          <PropLayout3 />
        </Route>
        {/* <Route path="/PaymentProposal">
          <PaymentProposal />
        </Route> */}
        <Route path="/paydetails" exact>
          <PaymentDetails />
        </Route>
        <Route path="/carpay" exact>
          <CarPaymentDetails />
        </Route>
        <Route path="/paydetailshealth" exact>
          <PaymentDetailsHealth />
        </Route>
        <Route path="/HealthCredit" exact>
          <HealthCredit />
        </Route>
        <Route path="/credit" exact>
          <Credit />
        </Route>
        <Route path="/IciciCredit" exact>
          <IciciCredit />
        </Route>
        <Route path="/carcredit" exact>
          <CarCredit />
        </Route>
        <Route path="/iciciCarCredit" exact>
          <IciciCarCredit />
        </Route>
        <Route path="/error" exact>
          <Error />
        </Route>
        <Route path="/payment" exact>
          <Paydone />
        </Route>
        {/* <Route path="/BreadcrumbBike" exact>
          <BreadcrumbBike />
        </Route> */}
        {/* New Vehicle Routes */}
        <Route path="/twoWheelMake" exact>
          <NewBikemake />
        </Route>
        <Route path="/newVehiclelayout" exact>
          <NewPlanLayoutBike />
        </Route>
        <Route path="/kyc-proposal" exact>
          <CustomerInfoNew />
        </Route>
        <Route path="/verify-payment" exact>
          <BikeLogin />
        </Route>
        <Route path="/request-payment" exact>
          <BikePaymentDetailNew />
        </Route>
        {/* Commerciaal */}

        <Route path="/commercial/:Ctype" exact>
          <ComVehType />
        </Route>
        <Route path="/commercial/:Ctype/details" exact>
          <PolicyStepC />
        </Route>
        <Route path="/commercial/:Ctype/quotes" exact>
          <PlanLayoutCommercial />
        </Route>
        <Route path="/commercial/quotes/proposal" exact>
          <CommercialCustomerInfo />
        </Route>
        <Route path="/commercialno" exact>
          {/* <Commercialnotodetails /> */}
          <ComRegister />
        </Route>
        <Route path="/disclaimer" exact>
          <Disclaimer />
        </Route>
        <Route path="/privacy-policy" exact>
          <PrivacyPolicy />
        </Route>
        <Route path="/terms-of-use" exact>
          <TermsOfUse />
        </Route>
        <Route path="/contact-us" exact>
          <Contact />
        </Route>

      </Switch>
    </>
  );
}

export default App;
